export default () => {
  const backButton = document.querySelector(".js-go-back");

  function handleGoBack() {
    window.history.back();
  }

  backButton?.addEventListener("click", handleGoBack);
};
